export const labelList = {
    btnPrevious: {
        fr: "Page précédente",
        en: "Previous"
    },
    btnNext: {
        fr: "Page suivante",
        en: "Next"
    },
    btnPrevious_aria: {
        fr: "Aller à la page précédente",
        en: "Previous"
    },
    btnNext_aria: {
        fr: "Aller à la page suivante",
        en: "Next"
    },
    btnReset: {
        fr: "Réinitialiser les filtres",
        en: "Reset"
    },
    btnFilter: {
        fr: "Appliquer les filtres",
        en: "Filter results"
    },

    result: {
        fr: "Résultats",
        en: "Results"
    },
    noResult: {
        fr: "Aucun résultat trouvé",
        en: "No results found"
    },
    navItem_aria: {
        fr: "Aller à la page ",
        en: "Go to page"
    },
    sort_aria: {
        fr: "Trier par",
        en: "Sort by"
    },
    sortAsc_aria: {
        fr: "croissant",
        en: "ascending"
    },
    sortDesc_aria: {
        fr: "décroissant",
        en: "descending"
    },
    errorMessage: {
        fr: "Le chargement des listes n’a pas fonctionné. Veuillez réessayer plus tard.",
        en: "The lists failed to load. Please try again later."
    },
    navItemResults_aria: {
        fr: "Nombre de résultats par page",
        en: "Number of results per page"
    },
    caption: {
        fr: "Résultats de recherche de thermopompes",
        en: "Heat pump search results"
    },
    table_aria: {
        fr: "Tableau des résultats de recherche de thermopompes",
        en: "Heat pump search results table"
    },
    tableDownload: {
        fr: "Exporter les résultats [CSV]",
        en: "Export results [CSV]"
    },
    search: {
        fr: "Recherche en cours...",
        en: "Searching..."
    }
};

export const paginationLabel = {
    page: {
        fr: (pageNumber) => `Page ${pageNumber}`,
        en: (pageNumber) => `Page ${pageNumber}`
    },
    of: {
        fr: "sur",
        en: "of"
    },
    items: {
        fr: (itemCount) => `${itemCount} résultats`,
        en: (itemCount) => `${itemCount} results`
    },
    resultsFound: {
      fr: (startItem, endItem, totalItems) => `Thermopompes efficaces ${startItem}-${endItem} sur ${totalItems} trouvées`,
      en: (startItem, endItem, totalItems) => `Efficient heat pumps ${startItem}-${endItem} of ${totalItems} found`
    },
    resultPerPage: {
        fr: "Résultats par page",
        en: "Results per page"
    },
    resultMessage:{
      fr: (totalResults) => `${totalResults} résultat${totalResults > 1 ? 's' : ''} trouvé${totalResults > 1 ? 's' : ''}`,
      en: (totalResults) => `${totalResults} result${totalResults > 1 ? 's' : ''} found${totalResults > 1 ? 's' : ''}`
    }
};

export const headingFieldsLabel = {
    "ahri": {
      label: {
        fr: "N° AHRI",
        en: "AHRI No."
      }
    },
    "marque": {
      label: {
        fr: "Marque",
        en: "Make"
      }
    },
    "modele_exterieur": {
      label: {
        fr: "N° de modèle - appareil extérieur",
        en: "Model No. of outdoor unit"
      }
    },
    "modele_interieur": {
      label: {
        fr: "N° de modèle - appareil intérieur",
        en: "Model No. of indoor unit"
      }
    },
    "fournaise": {
      label: {
        fr: "N° de modèle - Fournaise",
        en: "Model No. of furnace "
      }
    },
    "puissance_nominale": {
      label: {
        fr: "Puissance nominale (BTU/h)",
        en: "Nominal capacity (BTU/h)"
      }
    },
    "puissance_moins_8": {
      label: {
        fr: "Puissance à -8 °C (BTU/h)",
        en: "Capacity at -8 °C (BTU/h)"
      }
    },
    "aide_financiere": {
      label: {
        fr: "Subvention",
        en: "Grant"

      }
    },
    "aide_financiere_a": {
      label: {
        fr: "Subvention - Option efficacité",
        en: "Grant – Efficient option"

      }
    },
    "aide_financiere_b": {
      label: {
        fr: "Subvention - Option optimisation",
        en: "Grant – Optimized option"
      }
    },
    "haut_rendement": {
      label: {
        fr: "Modèle à très haute efficacité",
        en: "High-efficiency unit"
      }
    },

};

export const headingFieldsLabel_es= {
    "ahri_reference_number": {
      label: {
        fr: "N° AHRI",
        en: "AHRI No."
      }
    },
    "pd_id": {
      label: {
        fr: "N° Energy Star",
        en: "Energy Star No."
      }
    },
    "outdoor_unit_brand_name": {
      label: {
        fr: "Marque",
        en: "Make"
      }
    },
    "model_number": {
      label: {
        fr: "N° de modèle - appareil extérieur",
        en: "Model No. of outdoor unit"
      }
    },
    "indoor_unit_model_number": {
      label: {
        fr: "N° de modèle - appareil intérieur",
        en: "Model No. of indoor unit"
      }
    },
    "furnace_model_number": {
      label: {
        fr: "N° de modèle - Fournaise",
        en: "Model No. of furnace "
      }
    },
    "cooling_capacity_btu_h": {
      label: {
        fr: "Puissance nominale (BTU/h)",
        en: "Nominal capacity (BTU/h)"
      }
    },
    "heating_capacity_at_17_f_btu_h": {
      label: {
        fr: "Puissance à -8 °C (BTU/h)",
        en: "Capacity at -8 °C (BTU/h)"
      }
    },
    "TTG_AF_Maison1": {
      label: {
        fr: "Subvention",
        en: "Grant"
      }
    },
    "TTG_AF_EffAlone": {
      label: {
        fr: "Subvention",
        en: "Grant"
      }
    },
    "TTG_Ext2": {
      label: {
        fr: "Subvention",
        en: "Grant"
      }
    },

    "TTG_AF_Multi1": {
      label: {
        fr: "Subvention - Option efficacité",
        en: "Grant – Efficient option"

      }
    },
    "TTG_AF_Multi4": {
      label: {
        fr: "Subvention - Option optimisation",
        en: "Grant – Optimized option"
      }
    },
    "cold_climate": {
      label: {
        fr: "Modèle de type climat froid",
        en: "High-efficiency unit"
      }
    },
    "aide_financiere": {
      label: {
        fr: "Subvention",
        en: "Grant"

      }
    },
    "TTG_Ext5": {
      label: {
        fr: "TTG_Ext5",
        en: "TTG_Ext5"
      }
    },
     "TTG_colBonification": {
      label: {
        fr: "Bonification – Multilogements",
        en: "Bonus Financing for Multi‑Unit Dwellings"
      }
    },

};

export const headingFieldsLabel_custom = {
  "cooling_capacity_btu_h": { //ménages à revenu modeste
    label: {
      fr: "Capacité de refroidissement (BTU/h)",
      en: "Cooling capacity (BTU/h)"
    }
  }
};
export const screenReaderText = {
  sort: {
    label: {
      fr: (fieldLabel, directionLabel) => `Tri par ${fieldLabel} en ordre ${directionLabel}`,
      en: (fieldLabel, directionLabel) => `Sort by ${fieldLabel} in ${directionLabel} order`
    }
  },
  exportCSVSuccess: {
    label: {
      fr: (count) => `Export CSV réussi: ${count} enregistrements exportés`,
      en: (count) => `CSV export successful: ${count} records exported`
    }
  },
  exportCSVFail : {
    label: {
      fr: "Aucune donnée à exporter",
      en: "No data to export"
    }
  },
  itemsPerPage: {
    label: {
      fr: (newValue) => `Affichage modifié à ${newValue} résultats par page`,
      en: (newValue) => `Display changed to ${newValue} results per page`
    }
  }
};

export const validationLabels = {
  minMax: {
    label: {
      fr: (minValue, maxValue) => `Valeurs invalides. Veuillez saisir une valeur maximum supérieure ou égale à la valeur minimum (${maxValue}).`,
      en: (minValue, maxValue) => `The minimum value (${minValue}) must be less than the maximum value (${maxValue}).`
    }
  },
  minMax2: {
    label: {
      fr: (minValue, maxValue) => `Valeurs invalides. Veuillez saisir un montant maximum supérieur ou égale à la valeur minimum (${maxValue}).`,
      en: (minValue, maxValue) => `The maximum value (${maxValue}) must be greater than the minimum value (${minValue}).`
    }
  },
  invalid: {
    label: {
      fr: "Valeur invalide.",
      en: "Invalid value."
    }
  },
  invalidMinmax: {
    label: {
      fr: "Les valeurs minimale et maximale doivent être des nombres valides.",
      en: ""
    }
  },
   lengthNullAhri: {
    label: {
      fr: "Veuillez entrer un numéro AHRI.",
      en: "Please enter an AHRI number."
    }
  },
  lengthNullEnergyStar: {
    label: {
      fr: "Veuillez entrer un numéro Energy Star.",
      en: "Please enter an Energy Star number."
    }
  },
  lengthAHRI: {
    label: {
      fr: (min, max) => `Le numéro AHRI doit contenir entre ${min} et ${max} caractères.`,
      en: (min, max) => `The AHRI number must be between ${min} and ${max} characters long.`
    }
  },
  lengthEnergyStar: {
    label: {
      fr: () => `Le numéro Energy Star doit contenir 7 caractères.`,
      en: () => `The Energy Star number must be 7 characters long.`
    }
  },
  lengthMarque: {
    label: {
      fr: `Veuillez sélectionner un maximum de cinq marques.`,
      en: `Please select up to five makes.`
    }
  }
};

export const marqueLabels = {
  suggestions: {
    label: {
      fr: "suggestions trouvées. Sélectionnez votre choix à l'aide des flèches bas et haut.",
      en: "suggestions found. Select your choice using the up and down arrows."
    }
  },
  noResult: {
    label: {
      fr: "Aucun résultat trouvé",
      en: "No results found"
    }
  },
  loading: {
    label: {
      fr: "Chargement...",
      en: "Loading ..."
    }
  },
  added: {
    label: {
      fr: "ajouté à la liste.",
      en: "added to the list."
    }
  },
  removed: {
    label: {
      fr: "retiré de la liste.",
      en: "removed from the list."
    }
  },
  removeLabel: {
    label: {
      fr: "Retirer",
      en: "Remove"
    }
  },
  alreadySelected: {
    label: {
      fr: "est déjà sélectionné.",
      en: "is already selected."
    }
  }
};

export const simpleSearchRadioLabels = {
  label: {
    fr: {
      ahri: "Combinaison unique de 6 à 12 chiffres.",
      energystar: "Combinaison unique de 7 chiffres."

    },
    en: {
      ahri: "String of 6 to 12 numbers.",
      energystar: "String of 7 numbers."
    }
  }
}

export const simpleSearchLabels = {
  loading: {
    label: {
      fr: "Chargement des données...",
      en: "Loading data..."
    }
  },
  aideFinanciere: {
    label: {
      fr: "Subvention",
      en: "Grant"
    }
  },
  aideFinanciereEff: {
    label: {
      fr: "Subvention - Option efficacité",
      en: "Grant – Efficient option"
    }
  },
  aideFinanciereOpt: {
    label: {
      fr: "Subvention - Option optimisation",
      en: "Grant – Optimized option"
    }
  },
  votreTermo: {
    label: {
      fr: "Votre thermopompe",
      en: "Your heat pump"
    }
  },
  subvention: {
    label: {
      fr: "Subvention",
      en: "Grant"
    }
  },
  bonification: {
    label: {
      fr: "Bonification – Multilogements ",
      en: "Bonus Financing for Multi‑Unit Dwellings"
    }
  }
};

export const contentLanguage = {
    fr: {
      href: "/residentiel/mieux-consommer/aides-financieres/logisvert/archives-liste-thermopompes.html",
      prefix: "En cas de disparité, l’information contenue dans la ",
      linkText: "Liste des thermopompes admissibles au Programme",
      suffix: " prévaut sur celle présentée dans l’outil de recherche."
    },
    en: {
      href: "/residential/energy-wise/energy-grants/logisvert/archives-heat-pumps-list.html",
      linkText: "list of heat pumps eligible for the LogisVert Efficient Homes Program",
      prefix: "If there is a discrepancy, the information in the ",
      suffix: " takes precedence over the information presented in this search tool."
    }
  };

export const fields = [
  {
    key_neep: '',
    key_es:"pd_id",
    label: {
      fr: "Numéro de modèle ENERGY&nbsp;STAR<sup>®</sup>",
      en: "ENERGY STAR<sup>®</sup> ID"
    }
  },
  {
    key_neep: 'ahri',
    key_es:"ahri_reference_number",
    label: {
      fr: "Numéro AHRI",
      en: "AHRI No."
    }
  },
  {
    key_neep: 'marque',
    key_es: "outdoor_unit_brand_name",
    label: {
      fr: "Marque",
      en: "Make"
    }
  },
  {
    key_neep: 'modele_exterieur',
    key_es: "model_number",
    label: {
      fr: "Numéro de modèle de l’appareil extérieur",
      en: "Model No. of outdoor unit"
    }
  },
  {
    key_neep: 'modele_interieur',
    key_es  : "indoor_unit_model_number",
    label: {
      fr: "Numéro de modèle de l’appareil intérieur",
      en: "Model No. of indoor unit"
    }
  },
  {
    key_neep: 'fournaise',
    key_es: "furnace_model_number",
    label: {
      fr: "Numéro de modèle de la Fournaise",

      en: "Model No. of furnace"
    }
  },
  {
    key_neep: 'haut_rendement',
    key_es: "cold_climate",
    label: {
      fr: "Modèle à très haute efficacité",
      en: "High-efficiency unit"
    },
    label_es: {
      fr: "Modèle de type climat froid",
      en: "Cold Climate model"
    }
  },
  {
    key_neep: 'puissance_nominale',
    key_es: "cooling_capacity_btu_h",
    label: {
      fr: "Puissance nominale",
      en: "Nominal capacity"
    },
    suffix: {
      fr: " BTU/h",
      en: " BTU/h"
    }
  },
  {
    key_neep: 'puissance_moins_8',
    key_es: "heating_capacity_at_17_f_btu_h",
    label: {
      fr: "Puissance à -8&nbsp;°C",
      en: "Capacity at -8&nbsp;°C"
    },
    suffix: {
      fr: " BTU/h",
      en: " BTU/h"
    }
  },
];

export const filtresLabels = {
  fr: {
    optionRecherche: "Options de recherche",
    rechercheFiltres: "Recherche et filtres",
    marque: "Marque",
    erreurs: (totalErreurs) => `Erreur${totalErreurs > 1 ? "s" : ""}`,
    choixMarques: "Choisissez jusqu'à 5 marques",
    thermoHauteEfficacite: "Thermopompes à très haute efficacité",
    afficherThermoHauteEfficacite: "Afficher uniquement les thermopompes à très haute efficacité dans le tableau",
    fermer: "Fermer",
    afficherPuissanceNominale: "Afficher la puissance nominale dans le tableau",
    afficherPuissanceMoins8: "Afficher la puissance à -8°&nbsp;C dans le tableau",
    modeleExterieur: "Numéro de modèle de l’appareil extérieur",
    modeleInterieur: "Numéro de modèle de l’appareil intérieur",
    fournaise: "Numéro de modèle de la Fournaise",
    puissanceNominale: "Puissance nominale",
    puissanceMoins8: "Puissance à -8&nbsp;°C",
    aideFinanciere: "Montant de la subvention",
    btnAppliquer: "Appliquer les filtres",
    btnReset: "Réinitialiser les filtres",
    //ES
    thermoHauteEfficacite_es: "Thermopompes ENERGY STAR<sup>®</sup> –&nbsp;Climat froid",
    afficherThermoHauteEfficacite_es: "<span>Afficher uniquement les thermopompes ENERGY STAR<sup>®</sup> –&nbsp;Climat froid dans le tableau</span>",
    //CUSTOM
    afficherPuissanceNominale_custom: "Afficher la capacité de refroidissement dans le tableau",
    puissanceNominale_custom: "Capacité de refroidissement",
    //FECC
    admissible_bonification: "Afficher uniquement les thermopompes admissibles à la bonification Multilogements",
  },
  en: {
    optionRecherche: "Search options",
    rechercheFiltres: "Search and filters",
    marque: "Make",
    erreurs: (totalErreurs) => `Error${totalErreurs > 1 ? "s" : ""}`,
    choixMarques: "Please select up to five makes (manufacturers).",
    thermoHauteEfficacite: "High-efficiency heat pumps",
    afficherThermoHauteEfficacite: "Show only high-efficiency heat pumps in the table",
    fermer: "Close",
    afficherPuissanceNominale: "Show nominal capacity in the table",
    afficherPuissanceMoins8: "Show capacity at -8&nbsp;°C in the table",
    modeleExterieur: "Model No. of outdoor unit",
    modeleInterieur: "Model No. of indoor unit",
    fournaise: "Model No. of furnace",
    puissanceNominale: "Nominal capacity",
    puissanceMoins8: "Capacity at -8&nbsp;°C",
    aideFinanciere: "Amount of the grant",
    btnAppliquer: "Apply filters",
    btnReset: "Reset filters",
    //
    thermoHauteEfficacite_es: "ENERGY STAR<sup>®</sup> Cold Climate heat pumps",
    afficherThermoHauteEfficacite_es: "<span>Show only ENERGY STAR<sup>®</sup> Cold Climate heat pumps in the table</span>",
    afficherPuissanceNominale_custom: "Show only cooling capacity heat pumps in the table",
    puissanceNominale_custom: "Cooling capacity",
    //FECC
    admissible_bonification: "Show only heat pumps eligible for bonus financing for Multi‑unit dwellings"
  }
};
